import {NavLink} from "react-router-dom";
import {useDispatch} from "react-redux";
import {ThemeMode} from "../../../utils/helpers/constants";
import {removeLoggedInUser} from "../../../store/actions/auth.action";
import {toggleThemeState} from "../../../store/actions/component.action";

const MobileHeader = ({component}) => {
  const dispatch = useDispatch();

  const toggleTheme = () => dispatch(toggleThemeState(component.themeMode));

  const logoutUser = event => {
    event.preventDefault();
    dispatch(removeLoggedInUser());
  };

  return (
    <div className="mobile-main-header">
      <div className=" navbar navbar-expand-lg  nav nav-item  navbar-nav-right responsive-navbar navbar-dark">
        <div className={`collapse navbar-collapse ${component.mobileDropdownMode ? "show" : ""}`}
             id="navbarSupportedContent-4">
          <div className="d-flex ms-auto">
            <div className="main-header-notification">
              <span className="nav-link icon" onClick={toggleTheme}>
                {component.themeMode === ThemeMode.DARK_MODE ?
                  <i className="zmdi zmdi-sun text-dark"/> : <i className="zmdi zmdi-brightness-4 text-dark"/>
                }
              </span>
            </div>

            <div className="main-header-notification">
              <NavLink onClick={logoutUser} className="nav-link icon" to="/log-out">
                <i className="zmdi zmdi-power-off text-danger"/>
              </NavLink>
            </div>

            {/*{(TokenHelper.getOnboardingStatus() === "ONBOARDED" && TokenHelper.getUserType() === UserType.TENANT) &&*/}
            {/*  <GlobalSearchInput/>*/}
            {/*}*/}

          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileHeader;
